export default __webpack_public_path__ + "static/media/3.ca0e54ff.png";